module.exports = __webpack_public_path__ + "img/standard_rt.6b729a21.png";